"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WashPayload = exports.DispenseWithSessionPayload = exports.DispenseForUserPayload = exports.CreatedOrder = exports.CreateOrderPayload = exports.Order = exports.OrderStatus = exports.OrderQuery = exports.PackageListData = exports.SubscriptionPackage = exports.PackagePrice = exports.PackageListQuery = exports.StripeConfig = exports.StripeConfigQuery = exports.DrinkListData = exports.DevicePos = exports.DrinkListItem = exports.CatalogSubset = exports.CatalogConsumable = exports.Quantity = exports.DrinkListQuery = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const Json = __importStar(require("../../../../../json"));
const field_1 = require("../../../openapi/field");
exports.NAMESPACE = 'Culligan.Api.V1.Frontend.Vending.Schema';
/** Description on the property signature only, so a named schema stays a component. */
const described = (schema, description) => effect_1.Schema.propertySignature(schema).annotations({ description });
const appIdDescription = 'Client application id. Must belong to a registered, enabled client application, otherwise the request is rejected with 422.';
exports.DrinkListQuery = effect_1.Schema.Struct({
    serialNumber: (0, field_1.optionalString)('Serial number (device id) of a vending machine. When given, the list holds the drinks installed in that machine; otherwise the whole enhancement catalog. A repeated parameter is a 422.'),
}).annotations({
    identifier: `${exports.NAMESPACE}.DrinkListQuery`,
    description: 'Query of the drink list',
});
exports.Quantity = effect_1.Schema.Struct({
    _tag: described(effect_1.Schema.String, 'Unit of measure, for example Liter or Kilogram'),
    amount: described(effect_1.Schema.Number, 'Amount in that unit'),
}).annotations({
    identifier: `${exports.NAMESPACE}.Quantity`,
    description: 'An amount with its unit of measure',
});
exports.CatalogConsumable = effect_1.Schema.Struct({
    id: described(effect_1.Schema.String, 'Consumable id'),
    name: described(effect_1.Schema.String, 'Consumable name'),
    description: described(effect_1.Schema.String, 'Consumable description'),
    kind: described(effect_1.Schema.String, 'Consumable category'),
    type: described(effect_1.Schema.String, 'Record type of the legacy consumable'),
}).annotations({
    identifier: `${exports.NAMESPACE}.CatalogConsumable`,
    description: 'Consumable a catalog entry belongs to',
});
exports.CatalogSubset = effect_1.Schema.Struct({
    _tag: described(effect_1.Schema.String, 'Kind of consumable definition, for example LiquidEnhancement or CO2Tank'),
    id: described(effect_1.Schema.String, 'Definition id'),
    name: described(effect_1.Schema.String, 'Definition name'),
    depletable: described(effect_1.Schema.Boolean, 'Whether the consumable is used up by level'),
    expendable: described(effect_1.Schema.Boolean, 'Whether the consumable is used up by usage'),
    rangeTrigger: described(exports.Quantity, 'Level or usage that triggers the alarm'),
    rangeExhaust: described(exports.Quantity, 'Level or usage at which it is exhausted'),
})
    .pipe(effect_1.Schema.extend(effect_1.Schema.Record({ key: effect_1.Schema.String, value: Json.Value })))
    .annotations({
    identifier: `${exports.NAMESPACE}.CatalogSubset`,
    description: 'Consumable definition from the domain catalogue. Only the fields shared by all definitions are listed; the rest depend on _tag (for example rangeFullCapacity on depletable ones, flavor, ingredients and style on a LiquidEnhancement) and are returned as they are.',
});
exports.DrinkListItem = effect_1.Schema.Struct({
    consumable: exports.CatalogConsumable,
    subset: exports.CatalogSubset,
    type: described(effect_1.Schema.String, 'Category of the consumable'),
}).annotations({
    identifier: `${exports.NAMESPACE}.DrinkListItem`,
    description: 'One catalog entry of the drink list',
});
exports.DevicePos = effect_1.Schema.Struct({
    enabled: effect_1.Schema.optionalWith(effect_1.Schema.Boolean, { exact: true }).annotations({
        description: 'Whether the point of sale is enabled. Present in the default { enabled: false }; a stored setting may omit it.',
    }),
})
    .pipe(effect_1.Schema.extend(effect_1.Schema.Record({ key: effect_1.Schema.String, value: Json.Value })))
    .annotations({
    identifier: `${exports.NAMESPACE}.DevicePos`,
    description: 'Point-of-sale setting of the machine as stored on the device record; other stored fields are returned as they are',
});
exports.DrinkListData = effect_1.Schema.Struct({
    items: described(effect_1.Schema.Array(exports.DrinkListItem), 'Catalog entries'),
    pos: effect_1.Schema.optionalWith(exports.DevicePos, { exact: true }).annotations({
        description: 'Point-of-sale setting of the machine; { enabled: false } when the device record has none. Present only when serialNumber was given.',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.DrinkListData`,
    description: 'Drink list',
});
exports.StripeConfigQuery = effect_1.Schema.Struct({
    appId: (0, field_1.nonEmpty)(appIdDescription),
}).annotations({
    identifier: `${exports.NAMESPACE}.StripeConfigQuery`,
    description: 'Query of the Stripe client configuration',
});
exports.StripeConfig = effect_1.Schema.Struct({
    publishableKey: described(effect_1.Schema.String, 'Stripe publishable key for the client SDK'),
}).annotations({
    identifier: `${exports.NAMESPACE}.StripeConfig`,
    description: 'Stripe client configuration',
});
exports.PackageListQuery = effect_1.Schema.Struct({
    appId: (0, field_1.nonEmpty)(appIdDescription),
    type: (0, field_1.optionalString)('Package type. Only packages of that type are returned; omitted means all types.'),
    currency: (0, field_1.optionalString)('Currency code. Any string is accepted, the length is not checked. Defaults to "USD" when omitted. Packages without a price in that currency are left out. An empty string is not replaced by "USD": the currency filter is skipped, every enabled package is returned, and its price has no amount and formatted.'),
    countryCode: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.length(3)), { exact: true }).annotations({
        description: 'ISO 3166-1 alpha-3 country code, checked against the country list. Only packages that list the country are returned. A repeated parameter is not a 422: it gives an empty 200.',
    }),
    lang: effect_1.Schema.optionalWith(effect_1.Schema.String.pipe(effect_1.Schema.length(2)), { exact: true }).annotations({
        description: 'ISO 639-1 code, checked against the language list. Defaults to "en" when omitted. Packages without a translation in that language are left out. A repeated parameter is not a 422 but a 500.',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.PackageListQuery`,
    description: 'Query of the subscription package list',
});
exports.PackagePrice = effect_1.Schema.Struct({
    currency: described(effect_1.Schema.String, 'Currency of the price'),
    amount: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }).annotations({
        description: 'Price stored on the package for that currency. Missing when the request had an empty currency: no price is picked then.',
    }),
    formatted: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }).annotations({
        description: 'The same number as amount; it is not a formatted string. Missing together with amount.',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.PackagePrice`,
    description: 'Price of a subscription package',
});
exports.SubscriptionPackage = effect_1.Schema.Struct({
    id: described(effect_1.Schema.String, 'Package id'),
    name: described(effect_1.Schema.String, 'Package name'),
    days: described(effect_1.Schema.Number, 'Number of days the subscription lasts'),
    price: exports.PackagePrice,
    title: described(effect_1.Schema.NullOr(effect_1.Schema.String), 'Title in the requested language'),
    shortTitle: described(effect_1.Schema.NullOr(effect_1.Schema.String), 'Short title in the requested language'),
    tag: described(effect_1.Schema.NullOr(effect_1.Schema.String), 'Tag in the requested language'),
    description: described(effect_1.Schema.NullOr(effect_1.Schema.String), 'Description in the requested language'),
    type: described(effect_1.Schema.String, 'Package type'),
}).annotations({
    identifier: `${exports.NAMESPACE}.SubscriptionPackage`,
    description: 'Available subscription package, texts in the requested language',
});
exports.PackageListData = effect_1.Schema.Struct({
    items: described(effect_1.Schema.Array(exports.SubscriptionPackage), 'Enabled packages that match the filters; empty when none does'),
}).annotations({
    identifier: `${exports.NAMESPACE}.PackageListData`,
    description: 'Available subscription packages',
});
exports.OrderQuery = effect_1.Schema.Struct({
    orderId: (0, field_1.nonEmpty)('Order id, the id of the Stripe payment intent'),
}).annotations({
    identifier: `${exports.NAMESPACE}.OrderQuery`,
    description: 'Query of a subscription package order',
});
exports.OrderStatus = effect_1.Schema.Literal('succeeded', 'canceled', 'pending').annotations({
    identifier: `${exports.NAMESPACE}.OrderStatus`,
    description: 'Stripe succeeded and canceled are kept; any other Stripe status, including processing, is returned as pending',
});
exports.Order = effect_1.Schema.Struct({
    id: described(effect_1.Schema.String, 'Order id'),
    status: described(exports.OrderStatus, 'State of the payment'),
    optionId: described(effect_1.Schema.String, 'Id of the subscription package that was ordered'),
    userId: described(effect_1.Schema.String, 'Id of the user who owns the order'),
}).annotations({
    identifier: `${exports.NAMESPACE}.Order`,
    description: 'Subscription package order',
});
exports.CreateOrderPayload = effect_1.Schema.Struct({
    packageId: (0, field_1.nonEmpty)('Id of the subscription package to buy'),
    currency: (0, field_1.optionalString)('Currency code. Any string is accepted, the length is not checked. Defaults to "USD" when omitted. A currency the package has no price in makes the payment intent fail with 500.'),
}).annotations({
    identifier: `${exports.NAMESPACE}.CreateOrderPayload`,
    description: 'Request body to create a subscription package order',
});
exports.CreatedOrder = effect_1.Schema.Struct({
    orderId: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'Id of the order. Intended, but not returned today: the handler reads a property the service does not set.',
    }),
    paymentIntentSecret: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'Client secret of the payment intent. Intended, but not returned today: the handler reads a property the service does not set.',
    }),
    ephemeralKey: described(effect_1.Schema.String, 'Stripe ephemeral key for the customer'),
    customer: described(effect_1.Schema.String, 'Stripe customer id'),
}).annotations({
    identifier: `${exports.NAMESPACE}.CreatedOrder`,
    description: 'Data the client SDK needs to take the payment',
});
const serialNumberField = (0, field_1.nonEmpty)('Serial number (device id) of the vending machine');
const enhancementsField = effect_1.Schema.optionalWith(effect_1.Schema.Record({ key: effect_1.Schema.String, value: effect_1.Schema.Number }), {
    exact: true,
}).annotations({
    description: 'Selected enhancements, enhancement id to a number. Only "is an object" is checked, the values are not. A V1 device gets just the first key as the drink id; a V2 device gets the whole map.',
});
const waterTypeField = effect_1.Schema.optionalWith(effect_1.Schema.Int.pipe(effect_1.Schema.between(0, 4)), { exact: true }).annotations({
    description: 'Water type, a whole number from 0 to 4. The check also lets a numeric string through, and an array whose first element passes; the other elements are not checked, so [1, 99] and [1, "x"] pass too. Both are forwarded to the machine unchanged.',
});
const volumeField = effect_1.Schema.optionalWith(effect_1.Schema.Int.pipe(effect_1.Schema.greaterThanOrEqualTo(1)), {
    exact: true,
}).annotations({
    description: 'Drink size, a whole number of at least 1. The check also lets a numeric string through, and an array whose first element passes; the other elements are not checked, so [5, 0] and [5, "x"] pass too. Both are forwarded to the machine unchanged.',
});
exports.DispenseForUserPayload = effect_1.Schema.Struct({
    serialNumber: serialNumberField,
    sessionId: (0, field_1.optionalString)('Dispensing session id. Only a V1 machine receives it in the command; a V2 machine does not. An empty string is treated as not given.'),
    enhancements: enhancementsField,
    waterType: waterTypeField,
    volume: volumeField,
}).annotations({
    identifier: `${exports.NAMESPACE}.DispenseForUserPayload`,
    description: 'Request body to dispense a drink as a signed-in user',
});
exports.DispenseWithSessionPayload = effect_1.Schema.Struct({
    serialNumber: serialNumberField,
    sessionId: (0, field_1.nonEmpty)('Dispensing session id. Only a V1 machine receives it in the command; a V2 machine does not.'),
    enhancements: enhancementsField,
    waterType: waterTypeField,
    volume: volumeField,
}).annotations({
    identifier: `${exports.NAMESPACE}.DispenseWithSessionPayload`,
    description: 'Request body to dispense a drink with a session id or a subscription',
});
exports.WashPayload = effect_1.Schema.Struct({
    serialNumber: serialNumberField,
    sessionId: (0, field_1.nonEmpty)('Washing session id, passed to the machine'),
    enhancements: enhancementsField,
    waterType: waterTypeField,
    volume: volumeField,
}).annotations({
    identifier: `${exports.NAMESPACE}.WashPayload`,
    description: 'Request body to wash a bottle. enhancements, waterType and volume are validated but ignored.',
});
//# sourceMappingURL=schema.js.map